module.exports = __webpack_public_path__ + "5.jpg?e02453acef4107972e564b1af59f71ba";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/5.jpg
// module id = 60
// module chunks = 0